import React, { memo } from "react";
import { Modal } from "@shopify/polaris";
import intl from "../../../../../../i18n/intl";

const ArchiveOrderModal = memo(
  ({ archivedData, handleBulkOperationModal, handleArchiveConfigRequest }) => {
    return (
      <div>
        <Modal
          open={archivedData.ArchivedTipsActive}
          onClose={() => handleBulkOperationModal(false, false)}
          title={
            archivedData.setArchived ? "Archive orders" : "Unarchive orders"
          }
          primaryAction={{
            content: intl.get("Apply"),
            onAction: handleArchiveConfigRequest,
            loading: archivedData.archiveConfigloading,
          }}
          secondaryActions={[
            {
              content: intl.get("Cancel"),
              onAction: () => handleBulkOperationModal(false, false),
            },
          ]}
        >
          <Modal.Section>
            {archivedData.setArchived
              ? "Are you sure to archive orders?"
              : "Are you sure to unarchive orders?"}
          </Modal.Section>
        </Modal>
      </div>
    );
  }
);

export default ArchiveOrderModal;
